export default function Categories() {
  return <h1>Under construction</h1>;
}
